export default [
  {
    dataIndex:'nutritionName',
    scopedSlots: { customRender: 'nutritionName' },
    slots: { title: 'customTitle' },
    // title:'指标名称',
    newTitle:'指标名称',
    ellipsis:true,
    width: 160,
    fixed: 'left'
  },
  {
    dataIndex:'nutritionFullName',
    title:'指标全称',
    ellipsis:true,
    width: 150,
  },
  {
    dataIndex:'content',
    scopedSlots: { customRender: 'content' },
    title:'数值',
    sorter: (a, b) => a.content - b.content,
    sortDirections: ['descend', 'ascend'],
    align:'center',
    ellipsis:true,
    width: 100,
  },
  {
    dataIndex:'productContent',
    title:'产品',
    align:'center',
    sorter: (a, b) => a.productContent - b.productContent,
    sortDirections: ['descend', 'ascend'],
    scopedSlots: { customRender: 'productContent' },
    ellipsis:true,
    width:100
  },
  {
    dataIndex:'unit',
    title:'单位',
    width: 80,
    ellipsis:true,
  },
  {
    dataIndex:'minValue',
    scopedSlots: {customRender: 'minValue'},
    title: '最小值',
    sorter: (a, b) => a.minValue - b.minValue,
    sortDirections: ['descend', 'ascend'],
    align:'center',
    ellipsis:true,
    width:100,
  },
  {
    dataIndex:'maxValue',
    scopedSlots: {customRender: 'maxValue'},
    align:'center',
    title: '最大值',
    sorter: (a, b) => a.maxValue - b.maxValue,
    sortDirections: ['descend', 'ascend'],
    ellipsis:true,
    width:100,
  },
  {
    dataIndex:'cost',
    title:'单位成本',
    align:'center',
    sorter: (a, b) => a.cost - b.cost,
    scopedSlots: {customRender: 'cost'},
    sortDirections: ['descend', 'ascend'],
    ellipsis:true,
    width:150,
  },
  {
    dataIndex:'minApply',
    title:'适用下限',
    align:'center',
    sorter: (a, b) => a.minApply - b.minApply,
    scopedSlots: {customRender: 'minApply'},
    sortDirections: ['descend', 'ascend'],
    ellipsis:true,
    width:150,
  },
  {
    dataIndex:'maxApply',
    title:'适用上限',
    align:'center',
    sorter: (a, b) => a.maxApply - b.maxApply,
    scopedSlots: {customRender: 'maxApply'},
    sortDirections: ['descend', 'ascend'],
    ellipsis:true,
    width:150,
  },
  {
    dataIndex:'minLimitValue',
    scopedSlots: {customRender: 'minLimitValue'},
    align:'center',
    title: '极下限',
    sorter: (a, b) => a.minLimitValue - b.minLimitValue,
    sortDirections: ['descend', 'ascend'],
    ellipsis:true,
    width: 150,
  },
  {
    dataIndex:'maxLimitValue',
    scopedSlots: {customRender: 'maxLimitValue'},
    align:'center',
    title:'极上限',
    sorter: (a, b) => a.maxLimitValue - b.maxLimitValue,
    sortDirections: ['descend', 'ascend'],
    ellipsis:true,
    width: 150,
  },
  ]